<template>
	<b-container class="m-0 p-0">
		<b-button v-if="status === 'loading'" class="loading" variant="light">
			<b-spinner label="loading" small></b-spinner>
		</b-button>

		<b-button v-else-if="status === 'error'" class="error" variant="light">
			<b-icon icon="exclamation-circle" variant="danger"></b-icon>
		</b-button>

		<b-button
			v-else-if="managePatient.userID"
			class="class text-left px-2"
			:variant="managedPatientIsSignedUp ? 'primary' : isFull ? 'danger' : 'light'"
			:disabled="isFull && !managedPatientIsSignedUp"
			@click="managedPatientIsSignedUp ? adminRemoveUserFromClass(managedPatientAttendanceID) : adminAddUserToClass(managePatient.userID)"
		>{{ displayText }}</b-button>

		<b-button
			v-else-if="status === 'fetched'"
			class="class text-left px-2"
			:variant="Class.isSignedUp ? 'primary' : isFull ? 'danger' : 'light'"
			v-b-modal="modalID"
		>{{ displayText }}</b-button>

		<b-modal :id="modalID" :title="modalTitle" cancel-title="Back" size="lg" centered>
			<b-container fluid>
				<b-row no-gutters>
					<b-col cols="3">
						<strong>Video Call URL</strong>
					</b-col>
					<b-col md>
						<b-form-input v-model="Class.url" placeholder="Place Google Meet URL here"></b-form-input>
					</b-col>
				</b-row>

				<b-row class="text-center my-2">
					<b-col>
						<strong>Roster count</strong>
					</b-col>
					<b-col>
						<strong>Max attendees</strong>
					</b-col>
					<b-col>
						<strong>Instructor</strong>
					</b-col>
				</b-row>

				<b-row class="text-center my-2">
					<b-col>{{ Class.roster.length }}</b-col>
					<b-col>{{ Class.max }}</b-col>
					<b-col>
						<b-form-select
							v-model="Class.instructorID"
							:options="instructorOptions"
							class="my-2 text-center"
						></b-form-select>
					</b-col>
				</b-row>

				<b-row class="my-2">
					<b-col lg>
						<strong class="d-block my-1 text-center">Template</strong>
						<b-form-select
							v-model="Class.templateID"
							:options="templateOptions"
							class="my-2 text-center"
						></b-form-select>
					</b-col>
					<b-col class="text-center" lg>
						<strong class="d-block my-1">Roster</strong>
						<b-button-group
							v-for="attendee in Class.roster"
							:key="attendee.attendanceID"
							variant="light"
							class="attendee"
						>
							<b-button
								variant="danger"
								@click="adminRemoveUserFromClass(attendee.attendanceID)"
								size="sm"
								class="attendeeOption"
							>
								<b-icon icon="x-square"></b-icon>
							</b-button>

							<b-button
								id="btnGroupName"
								variant="light"
							>{{ attendee.firstName + " " + attendee.lastName }}</b-button>

							<b-button
								:variant="attendee.attended ? 'primary' : 'warning'"
								@click="updateAttendance(attendee.attendanceID, !attendee.attended)"
								size="sm"
								class="attendeeOption"
							>
								<b-icon :icon="attendee.attended ? 'person-check' : 'person-dash'" class="my-1"></b-icon>
							</b-button>
						</b-button-group>
					</b-col>
				</b-row>
			</b-container>

			<template v-slot:modal-footer>
				<b-container fluid>
					<b-button variant="danger" class="float-right mx-2" @click="adminDeleteClass()">Delete Class</b-button>

					<b-button variant="primary" class="float-right mx-2" @click="update()">Update</b-button>

					<b-button
						variant="success"
						class="float-right mx-2"
						:disabled="Class.roster.length === Class.max"
						@click="$root.$emit('bv::show::modal', seachModalID)"
					>Add To Roster</b-button>

					<b-button
						variant="secondary"
						class="float-right mx-2"
						@click="$root.$emit('bv::hide::modal', modalID)"
					>Back</b-button>
				</b-container>
			</template>
		</b-modal>

		<b-modal :id="seachModalID" title="Patient Search" ok-only ok-title="Back" ok-variant="secondary">
			<b-container fluid>
				<b-row>
					<b-col>
						<b-form-input
							id="searchInput"
							placeholder="eg. John Doe"
							class="text-center w-75 mx-auto"
							v-model="searchQuery"
							@update="adminPatientSearch()"
						></b-form-input>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-button
							v-for="patient in searchResults"
							:key="patient.userID"
							@click="adminAddUserToClass(patient.userID)"
							variant="light"
							class="searchResult"
						>{{ patient.firstName + " " + patient.lastName }}</b-button>
					</b-col>
				</b-row>
			</b-container>
		</b-modal>
	</b-container>
</template>

<script>
// 6 -> 06
function padWithZero(day) {
	if (day.length === 1) {
		return "0" + day
	} else {
		return day
	}
}

export default {
	name: "ClassAdmin",
	data() {
		return {
			status: "loading",
			Class: {
				date: "",
				time: "",
				max: 0,
				isSignedUp: false,
				templateID: 0,
				instructorID: 0,
				url: "",
				roster: [],
			},
			searchQuery: "",
			searchResults: [],
			instructorOptions: [],
			templateOptions: [],
		}
	},
	props: {
		classID: {
			type: Number,
			required: true,
		},
		year: {
			type: Number,
			required: false,
		},
		month: {
			type: Number,
			required: false,
		},
		day: {
			type: Number,
			required: true,
		},
	},
	computed: {
		timeString() {
			try {
				if (parseInt(this.Class.time.substr(0, 2)) === 12) {
					return this.Class.time.substr(0, 5) + "PM"
				} else if (parseInt(this.Class.time.substr(0, 2)) > 12) {
					// Get hour substring from full time string
					// convert to integer and deduct 12
					// pad with zero if necessary
					// append PM
					return (
						padWithZero(
							(parseInt(this.Class.time.substr(0, 2)) - 12).toString()
						) +
						this.Class.time.substr(2, 3) +
						"PM"
					)
				} else {
					return this.Class.time.substr(0, 5) + "AM"
				}
			} catch {
				return ""
			}
		},
		displayText() {
			try {
				return this.timeString + " - " + this.templateOptions.find(option => option.value === this.Class.templateID).text
			} catch {
				return ""
			}
		},
		modalTitle() {
			try {
				return (
					new Date(this.year, this.month, this.day, 0,0,0,0).toDateString() +
					" @ " +
					this.displayText
				)
			} catch {
				return ""
			}
		},
		isFull() {
			if (this.Class.roster.length === this.Class.max) {
				return true
			} else {
				return false
			}
		},
		isAdmin() {
			return this.$store.getters.isAdmin
		},
		modalID() {
			return "classDetails-" + this.classID.toString()
		},
		seachModalID() {
			return "search-" + this.classID.toString()
		},
		managePatient() {
			return this.$store.state.managePatient
		},
		managedPatientIsSignedUp() {
			return this.Class.roster
				.map(attendee => attendee.userID)
				.includes(this.managePatient.userID)
		},
		managedPatientAttendanceID() {
			if (this.managedPatientIsSignedUp) {
				return this.Class.roster.filter(
					attendee => attendee.userID === this.managePatient.userID
				)[0].attendanceID
			} else {
				return 0
			}
		},
	},
	methods: {
		getClassDetails: function() {
			return new Promise((resolve, reject) => {
				fetch(this.$apiURL + "/adminOnlineClassDetails", {
					method: "POST",
					body: JSON.stringify({
						classID: this.classID,
					}),
					headers: new Headers({
						Authorization: this.$store.state.token,
						"Content-Type": "application/json",
					}),
				}).then(res => {
					if (res.ok) {
						res.json().then(Class => {
							this.Class = Class
							resolve()
						})
					} else {
						reject(res)
					}
				})
			})
		},
		updateClass: function() {
			return new Promise((resolve, reject) => {
				fetch(this.$apiURL + "/adminOnlineClassDetails", {
					method: "POST",
					body: JSON.stringify({
						classID: this.classID,
					}),
					headers: new Headers({
						Authorization: this.$store.state.token,
						"Content-Type": "application/json",
					}),
				}).then(res => {
					if (res.ok) {
						res.json().then(Class => {
							// Only overwrite current class data if new data is different
							if (this.Class === Class) {
								resolve()
							} else {
								this.Class = Class
								resolve()
							}
						})
					} else {
						reject(res)
					}
				})
			})
		},
		adminRemoveUserFromClass: function(attendanceID) {
			if (confirm("Remove user from this class?")) {
				return new Promise((resolve, reject) => {
					fetch(this.$apiURL + "/adminRemoveUserFromOnlineClass", {
						method: "POST",
						headers: new Headers({
							Authorization: this.$store.state.token,
							"Content-Type": "application/json",
						}),
						body: JSON.stringify({
							attendanceID: attendanceID,
						}),
					}).then(res => {
						if (res.ok) {
							// Successfully removed user from class
							this.updateClass()
							resolve()
						} else {
							// Server error
							alert("Server error, try again.")
							reject()
						}
					})
				})
			}
		},
		adminPatientSearch: function() {
			return new Promise((resolve, reject) => {
				if (this.searchQuery.length < 3) {
					// Dont query or show any results if query string is less than 3 chars
					this.searchResults = []
					resolve()
				} else {
					fetch(this.$apiURL + "/adminPatientSearchQuery", {
						method: "POST",
						headers: new Headers({
							Authorization: this.$store.state.token,
							"Content-Type": "application/json",
						}),
						body: JSON.stringify({
							query: this.searchQuery,
							classID: this.classID,
							online: true,
						}),
					}).then(res => {
						if (res.ok) {
							res.json().then(results => {
								this.searchResults = results
								resolve()
							})
						} else {
							// Server error
							reject()
						}
					})
				}
			})
		},
		adminAddUserToClass: function(userID) {
			return new Promise((resolve, reject) => {
				fetch(this.$apiURL + "/adminAddUserToOnlineClass", {
					method: "POST",
					headers: new Headers({
						Authorization: this.$store.state.token,
						"Content-Type": "application/json",
					}),
					body: JSON.stringify({
						userID: userID,
						classID: this.classID,
					}),
				}).then(res => {
					if (res.ok) {
						this.updateClass().then(() => {
							if (!this.managePatient.userID) {
								this.$root.$emit("bv::hide::modal", this.seachModalID)
								this.searchQuery = ""
								this.searchResults = []
							}
						})
					} else {
						reject()
					}
				})
			})
		},
		adminDeleteClass: function() {
			return new Promise((resolve, reject) => {
				if (confirm("Are you sure you want to delete this class?")) {
					fetch(this.$apiURL + "/adminDeleteOnlineClass", {
						method: "POST",
						headers: new Headers({
							Authorization: this.$store.state.token,
							"Content-Type": "application/json",
						}),
						body: JSON.stringify({
							classID: this.classID,
						}),
					}).then(res => {
						if (res.ok) {
							this.$root.$emit("bv::hide::modal", this.modalID)
							this.$parent.updateDay().then(() => {
								resolve()
							})
						} else {
							// Server error
							alert(
								"An error has occured. Make sure class has no attendees before deleting."
							)
							this.updateClass().then(() => {
								reject()
							})
						}
					})
				} else {
					resolve()
				}
			})
		},
		update: function() {
			if (this.Class.instructorID === 0 || this.Class.templateID === 0) {
				alert("You must select a template and instructor")
			} else {
				return new Promise((resolve, reject) => {
					fetch(this.$apiURL + "/updateOnlineClass", {
						method: "POST",
						headers: new Headers({
							Authorization: this.$store.state.token,
							"Content-Type": "application/json",
						}),
						body: JSON.stringify({
							classID: this.classID,
							newURL: this.Class.url,
							instructorID: this.Class.instructorID,
							templateID: this.Class.templateID,
						}),
					}).then(res => {
						if (res.ok) {
							alert("Class updated")
						} else {
							// Server error
							alert("An error has occured. Try again.")
							this.updateClass().then(() => {
								reject()
							})
						}
					})
				})
			}
		},
		updateAttendance: function(attendanceID, newAttended) {
			return new Promise((resolve, reject) => {
				fetch(this.$apiURL + "/adminSetOnlineClassAttendance", {
					method: "POST",
					headers: new Headers({
						Authorization: this.$store.state.token,
						"Content-Type": "application/json",
					}),
					body: JSON.stringify({
						attendanceID: attendanceID,
						newAttended: newAttended,
					}),
				}).then(res => {
					if (res.ok) {
						this.updateClass().then(() => {
							resolve()
						})
					} else {
						// Server error
						alert("An error has occured. Try again.")
						this.updateClass().then(() => {
							reject()
						})
					}
				})
			})
		},
		fetchInstructorsAndTemplates: function() {
			return new Promise((resolve, reject) => {
				fetch(this.$apiURL + "/getTemplatesAndInstructors", {
					method: "GET",
					headers: new Headers({
						Authorization: this.$store.state.token,
						"Content-Type": "application/json",
					}),
				}).then(res => {
					if (res.ok) {
						res.json().then(res => {
							// Reset to initial placeholder option, then append data
							this.instructorOptions = [
								{
									value: 0,
									text: "Select an instructor...",
								},
							]
							this.templateOptions = [
								{
									value: 0,
									text: "Select a template...",
								},
							]
							res.instructors.forEach(instructor => {
								this.instructorOptions.push(instructor)
							})
							res.templates.forEach(template => {
								this.templateOptions.push(template)
							})
							resolve()
						})
					} else {
						console.error("Error fetching instructors and templates")
						reject()
					}
				})
			})
		},
	},
	created() {
		this.getClassDetails().then(async () => {
			this.status = "fetched"
			await this.fetchInstructorsAndTemplates()
		})
	},
	mounted() {
		this.$root.$on('bv::modal::hide', async (_, modalID) => {
			if (modalID.includes('classDetails-')) {
				await this.updateClass()
			}
		})
	}
}
</script>

<style scoped>
.error,
.loading,
.class {
	display: block;
	margin: 8px auto;
	width: 100%;
}

strong {
	vertical-align: middle;
	text-align: center;
}

.attendee {
	border: 1px solid black;
	border-radius: 5px;
	width: 100%;
	margin: 5px auto;
}

.attendeeOption {
	width: 30px;
}

#btnGroupName {
	pointer-events: none;
	width: 250px;
}

.searchResult {
	display: block;
	width: 80%;
	margin: 15px auto;
	border: 1px solid grey;
}
</style>
